import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D036C297-DB1B-42F5-A856-13EEBDB48613
 * name flask-empty
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flask-empty.svg
 * tags
 * - Science 
 * - Gaming / RPG 
 */
export const FlaskEmptyIcon = createSvgIcon(<><path d="M6,22A3,3 0 0,1 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6A1,1 0 0,1 8,5V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V5A1,1 0 0,1 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19A3,3 0 0,1 18,22H6Z" /></>, 'FlaskEmptyIcon');
export default FlaskEmptyIcon